import { useEffect } from 'react'
import { loadNameFont, nameCss } from '@/lib/decor'
import type { NameStyle } from '@/types/api'

interface Props {
  name: string
  style?: NameStyle | null | undefined
  className?: string | undefined
}

/**
 * Имя со стилем ника: шрифт, цвет, градиент или свечение. Без стиля — просто текст, и цвет
 * берётся у родителя (цвет роли или обычный).
 */
export function StyledName({ name, style, className }: Props) {
  const font = style?.font_id
  useEffect(() => {
    if (font !== undefined) loadNameFont(font)
  }, [font])
  if (!style) return className ? <span className={className}>{name}</span> : <>{name}</>
  return (
    <span className={className} style={nameCss(style)} data-name-style="">
      {name}
    </span>
  )
}
